<template>
  <div class="home">
    <div class="alert alert-danger" style="display: none" id="pay_block">
      Please settle the following installments before accessing the subjects.
      <ul>
        <li v-for="(block, k) in block_payment" :key="k">
          installment {{ block.installment_no }} ({{ currency.symbol }}
          {{ numberWithCommas(block.outstanding_amount) }})<sup>{{
            currency.code
          }}</sup>
        </li>
      </ul>
    </div>
    <!-- begin::reconsilation validation block -->
    <div class="alert alert-danger" style="display: none" id="reconsile_block">
      Please wait for the payment reconciliation process completed before accessing the subjects.
      <ul>
        <li v-if="block_reconsile">
          Reconciliation pending for some installment\s
        </li>
      </ul>
    </div>
    <!-- end::reconsilation validation block -->
    <div class="row subject-page">
      <div class="col-md-12">
        <!--begin::Portlet-->
        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption col-md-12">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                  {{ course_statics.code }} : {{ course_statics.name }}
                </h3>
              </div>
            </div>
            <div class="m-portlet__head-back_button col-md-6 text-right">
              <router-link to="/course" tag="button" class="btn btn-info mt-4">
                Back
              </router-link>
            </div>
          </div>
          <div class="m-portlet__body">
            <div class="row">
              <div class="col-md-8 col-sm-12 padding-r-7">
                <div class="top-desc">
                  <div class="card new-card">
                    <div class="card-header">Description</div>
                    <div class="card-body">
                      <p>{{ course_statics.description }}</p>
                    </div>
                  </div>
                </div>
                <div class="top-desc left-panel cus-left">
                  <div class="card new-card">
                    <div class="card-header">Subjects</div>
                    <div class="card-body" style="padding-top: 15px">
                      <div class="row" v-if="loaderlist">
                        <div
                          class="
                            col-md-4 col-lg-4 col-xl-4
                            subject-col
                            padding-r-7
                          "
                        >
                          <div class="modern-card loading-box">
                            Data loading...
                            <facebook-loader></facebook-loader>
                          </div>
                        </div>
                        <div
                          class="
                            col-md-4 col-lg-4 col-xl-4
                            subject-col
                            mobile-hide
                          "
                        >
                          <div class="modern-card loading-box">
                            Data loading...
                            <facebook-loader></facebook-loader>
                          </div>
                        </div>
                        <div
                          class="
                            col-md-4 col-lg-4 col-xl-4
                            subject-col
                            padding-l-7
                            mobile-hide
                          "
                        >
                          <div class="modern-card loading-box">
                            Data loading...
                            <facebook-loader></facebook-loader>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div
                          class="col-md-4 col-lg-4 col-xl-4 pr-0"
                          v-for="(item, index) in subject_detail"
                          :key="index"
                        >
                          <div
                            class="modern-card"
                            @click="gotoSubject(item.id)"
                          >
                            <div
                              class="modern-head"
                              :style="{
                                'background-color': item.icon_bg_color,
                              }"
                            >
                              <h2>{{ item.name }}</h2>
                              <div class="icon-area">
                                <i
                                  :class="item.link_icon"
                                  class="m-menu__link-icon"
                                ></i>
                              </div>
                            </div>
                            <div class="modern-stat p-0">
                              <div class="row pt-2 pb-2 pr-1 pl-1">
                                 <div class="col-12 col-sm-12 col-xs-12 col-md-4 col-lg-4 text-center sub-items-border-right">
                                    <span v-if="item.duration == 0">
                                      {{ item.duration }} Hours
                                    </span>
                                    <span v-if="item.duration == 1">
                                      {{ item.duration }} Hour
                                    </span>
                                      <span v-if="item.duration > 1">
                                      {{ item.duration }} Hours
                                    </span>
                              </div>
                              <div class="col-12 col-sm-12 col-xs-12 col-md-4 col-lg-4 text-center sub-items-border-right">
                                <!-- <div class="dot"></div> -->
                                    <span v-if="item.topicsCount == 0">
                                      {{ item.topicsCount }} Topics
                                    </span>
                                    <span v-if="item.topicsCount == 1">
                                      {{ item.topicsCount }} Topic
                                    </span>
                                      <span v-if="item.topicsCount > 1">
                                      {{ item.topicsCount }} Topics
                                    </span>
                              </div>
                              <div class="col-12 col-sm-12 col-xs-12 col-md-4 col-lg-4 text-center">
                                <!-- <div class="dot"></div> -->
                                {{ item.code }}
                              </div>
                              </div>
                            </div>
                            <div class="modern-body modern-body-description">
                               <p class="description-text" v-if="item.description">
                                {{
                                  item.description &&
                                  item.description.length > 85
                                    ? item.description.substring(0, 85) + ".."
                                    : item.description
                                }}
                              </p>
                              <p class="description-text" v-else>
                                No description available...
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="teacher_panel">
                  <Teachers></Teachers>
                </div>
              </div>
              <div class="col-md-4 col-sm-12 padding-l-7">
                <div class="right-panel">
                  <div v-if="course_statics.remaining > 0" class="stat due-set">
                    <h2>Payment Details</h2>
                    <h5>
                      Total payable amount
                      <span
                        >{{ currency.symbol }}
                        {{ numberWithCommas(course_statics.remaining) }}
                        <sup>{{ currency.code }}</sup></span
                      >
                    </h5>
                  </div>
                  <div
                    v-if="clientId == 284"
                    class="stat due-set clientAccountBlock"
                  >
                    <h2>Institute Account Details</h2>
                    <div class="account-details">
                      <h5>
                        Account Holder Name
                        <span>H.W.M.P. Kumara</span>
                      </h5>
                      <h5>
                        Bank / Branch
                        <span>BOC Peradeniya</span>
                      </h5>
                      <h5>
                        Account Number
                        <span>77776896</span>
                      </h5>
                    </div>
                  </div>
                  <div
                    class="stat othe-link"
                    style="padding-bottom: 0 !important"
                  >
                    <div v-if="course_payments">
                      <Payment @getCourse="getCourseStatics"></Payment>
                    </div>
                  </div>
                  <!-- <div class="due-set"> -->
                  <!-- <a href="" v-if="course_statics.remaining !== 0" class="btn btn-info">Pay Now</a>
                    <span class="badge badge-success" v-else>No Due</span> -->
                  <!-- </div> -->
                  <div class="stat">
                    <h2 style="margin-bottom: 0">My Course Statistics</h2>
                  </div>
                  <div class="stat custom-p">
                    <div class="progress-area">
                      <span
                        >Course Completion ({{
                          course_statics.courseProgress
                        }}%)</span
                      >
                      <div class="progress">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          :style="
                            'width: ' + course_statics.courseProgress + '%'
                          "
                          :aria-valuenow="course_statics.courseProgress"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                    <!-- <div class="progress-area">
                      <span>Attendance (80%)</span>
                      <div class="progress">
                        <div class="progress-bar" role="progressbar" style="width: 50%" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div> -->
                    <div class="progress-area">
                      <span>Marks ({{ marks_percentage }}%)</span>
                      <div class="progress">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          :style="'width: ' + marks_percentage + '%'"
                          :aria-valuenow="marks_percentage"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      <label for=""
                        ><small
                          >Calculated only for the marked assignments</small
                        ></label
                      >
                    </div>
                  </div>
                  <!-- <div class="stat othe-link">
                    <h2>Other Links</h2>
                    <ul>
                      <li><a href="#">Assignment History</a></li>
                      <li><a href="#">Time Table</a></li>
                      <li><a href="#">Course Attendance</a></li>
                      <li><a href="#">Payment History</a></li>
                    </ul>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Portlet-->
      </div>
    </div>
  </div>
</template>

<script>
import { FacebookLoader } from "vue-content-loader";
import Teachers from "@/views/Teachers";
import Payment from "@/components/template/Payment";
var Config = require("../router/Config");
// var Teachers = require('../views/Teachers')
var $ = require("jquery");
var Cookies = require("vue-cookies");
var userPermissions = Cookies.get("userPermissions");

var Subjects = {
  name: "subjects",
  components: { FacebookLoader, Teachers, Payment },
  props: [],
  data() {
    return {
      loaderlist: true,
      subject_detail: [],
      course_statics: [],
      marks_percentage: 0,
      course_payments: [],
      isPayment: false,
      user: [],
      block_payment: [],
      block_reconsile: [],
      currency: [],
      clientId: Cookies.get("clientId"),
    };
  },
  beforeCreate: function () {
    if (!userPermissions.course_view) {
      this.$router.push("/");
    }
  },
  mounted() {
    this.getSubjects();
    this.currency = Cookies.get("currency");
    this.getCourseStatics();
    this.user = Cookies.get("userDetail");
    if (userPermissions.check_payment) {
      this.checkPayment();
    }
  },
  methods: {
    getSubjects: function () {
      this.axios
        .get(
          Config.API_URL +
            "/api/fe/course/subjects/" +
            Cookies.get("courseId") +
            "?token=" +
            Cookies.get("accessToken")
        )
        .then((response) => {
          var subjectData = response.data;
          this.subject_detail = subjectData.data;
          this.loaderlist = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getCourseStatics: function () {
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/course/statics/" +
            Cookies.get("userId") +
            "/" +
            Cookies.get("studentId") +
            "/" +
            Cookies.get("clientId") +
            "/" +
            Cookies.get("courseId") +
            "?token=" +
            Cookies.get("accessToken"),
          {
            is_bundle: Cookies.get("is_bundle"),
            bundle_course_id: Cookies.get("bundle_course_id"),
          }
        )
        .then((response) => {
          this.course_statics = response.data.data;
          this.marks_percentage = this.course_statics.marksPercentage;
          this.course_payments = this.course_statics.payments_all;
          this.isPayment = true;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    gotoSubject: function (subjectId) {
      var courseID = Cookies.get("courseId");
      if (Cookies.get("is_bundle") === "true") {
        courseID = Cookies.get("bundle_course_id");
      }
      if (userPermissions.check_payment) {
        this.axios
          .post(
            Config.API_URL +
              "/api/fe/payments/check?token=" +
              Cookies.get("accessToken"),
            {
              user_id: this.user.student[0].id,
              course_id: courseID,
            }
          )
          .then((response) => {
            this.block_payment = response.data.data;
            if (response.data.is_can) {
              //  check if the reconsilation process done

              this.axios
                .post(
                  Config.API_URL +
                    "/api/fe/payments/check-reconcilation?token=" +
                    Cookies.get("accessToken"),
                  {
                    user_id: this.user.student[0].id,
                    course_id: courseID,
                  }
                )
                .then((response) => {
                  this.block_reconsile = response.data.data;
                  if (response.data.is_can) {
                    Cookies.set("subjectId", subjectId);
                    this.$router.replace({ name: "chapters" });
                  } else {
                    $("#reconsile_block")
                      .fadeTo(5000, 500)
                      .slideUp(500, function () {
                        $("#reconsile_block").slideUp(500);
                      });
                  }
                })
                .catch(function (error) {
                  console.log(error);
                });
            } else {
              $("#pay_block")
                .fadeTo(5000, 500)
                .slideUp(500, function () {
                  $("#pay_block").slideUp(500);
                });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        Cookies.set("subjectId", subjectId);
        this.$router.replace({ name: "chapters" });
      }
    },
    checkPayment: function () {
      var courseID = Cookies.get("courseId");
      if (Cookies.get("is_bundle") === "true") {
        courseID = Cookies.get("bundle_course_id");
      }
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/payments/check?token=" +
            Cookies.get("accessToken"),
          {
            user_id: this.user.student[0].id,
            course_id: courseID,
          }
        )
        .then((response) => {
          this.block_payment = response.data.data;
          if (!response.data.is_can) {
            $("#pay_block")
              .fadeTo(5000, 500)
              .slideUp(500, function () {
                $("#pay_block").slideUp(500);
              });
          } else {
            this.checkReconsilation();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    checkReconsilation: function () {
      console.log("called");
      var courseID = Cookies.get("courseId");
      if (Cookies.get("is_bundle") === "true") {
        courseID = Cookies.get("bundle_course_id");
      }
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/payments/check-reconcilation?token=" +
            Cookies.get("accessToken"),
          {
            user_id: this.user.student[0].id,
            course_id: courseID,
          }
        )
        .then((response) => {
          console.log("resp", response);
          this.block_reconsile = response.data.data;
          if (!response.data.is_can) {
            $("#reconsile_block")
              .fadeTo(5000, 500)
              .slideUp(500, function () {
                $("#reconsile_block").slideUp(500);
              });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
export default Subjects;
</script>

<style scoped lang="scss">
@import "../assets/scss/component/subject/subject";

@media (max-width:767px) {
  .sub-items-border-right {
    border-right: none !important;
  }
}

.sub-items-border-right {
  border-right:1px solid rgba(0, 0, 0, 0.125);
}

.modern-body .modern-body-description {
  padding: 10px;
}

.modern-body .description-text {
  font-weight: 700;
  color: #222;
}


</style>
